import type { GenericFormType } from '@neo/blocks/forms/types'
import { Skeleton } from '@neo/primitives/skeleton'
import { useCrawlStatus } from 'v2/pages/flow/knowledge-base/queries'
import { useEffect } from 'react'
import type { NewKBFormValues } from '../../types'

export const LinksSkeleton = ({ form }: { form: GenericFormType<NewKBFormValues> }) => {
  const jobId = form.useStore((state) => state.values.jobId)
  const { data } = useCrawlStatus(jobId)

  useEffect(() => {
    const pages = data?.data?.pages
    if (data?.data?.status === 'completed') {
      if (pages?.length) {
        const parsedPages = pages.map((page) => ({
          url: page.url,
          id: page.id,
          title: page.title,
          markdown: page.markdown,
          selected: true,
        }))
        form.setFieldValue('links', parsedPages)
        form.validateAllFields('change')
      }
      form.setFieldValue('isLoading', false)
    }
  }, [data])

  return (
    <div className="col-span-full">
      <div className="p-2">
        <div className="flex gap-2 justify-between items-center border-b pb-2 px-4 mb-4">
          <div className="flex items-center text-p-500">
            <div className="text-p-500">
              <Skeleton className="w-[90px] max-w-full" />
            </div>
          </div>
          <span>
            <Skeleton className="w-[216px] max-w-full" />
          </span>
        </div>
        <div className="relative flex flex-col gap-1 max-h-[500px] pr-2 -mr-2">
          <style>
            <Skeleton className="w-[1611px] max-w-full" />
          </style>
          <div className="h-full w-full pb-1 [&amp;>div]:!block">
            <div>
              {[1, 2, 3].map((i) => (
                <div key={i} className="px-4 py-1">
                  <div className="flex items-center text-p-500 flex-1">
                    <div className="text-p-500 w-full">
                      <div className="flex flex-col">
                        <p className="text-p-500">
                          <Skeleton className="w-[136px] max-w-full" />
                        </p>
                        <p className="text-p-400">
                          <Skeleton className="w-[298px] max-w-full" />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
